<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolLearningManagementSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "/school/learning-management/class-notes",
                title: "Class Notes",
                description: "Create and share lesson notes with students and classes.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/learning-management/lesson-plans",
                title: "Lesson Plans",
                description: "Prepare and organize lesson plans for upcoming classes.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/learning-management/assignments",
                title: "Assignments",
                description: "Create assignments and review student submissions.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
